import React, { useState } from "react";
import emailjs from "emailjs-com";
import Reveal from "./Reveal";

const Contact = () => {
  const [form, setForm] = useState({ userEmail: "", subject: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .send(
        "service_zyidoao",
        "template_xckrck5",
        {
          from_name: form.userEmail,
          to_name: "Alexander Lasson",
          subject: form.subject,
          message: form.message,
        },
        "ylbqRvfZcWPdQER_f"
      )
      .then(() => {
        setStatus("sent");
        setForm({ userEmail: "", subject: "", message: "" });
      })
      .catch(() => setStatus("error"));
  };

  const inputClasses =
    "w-full p-3 rounded-xl bg-black/40 border border-white/15 text-white placeholder-white/40 " +
    "focus:outline-none focus:border-ember/70 focus:ring-1 focus:ring-ember/50 transition-colors";

  return (
    <section
      id="contact"
      className="relative min-h-screen flex flex-col justify-between pt-28 px-6"
    >
      <div className="max-w-2xl mx-auto w-full">
        <Reveal>
          <p className="text-sm font-semibold tracking-[0.3em] uppercase text-ember text-shadow mb-2 text-center">
            03 · Contact
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white text-shadow-strong mb-4 text-center">
            Let's build something
          </h2>
          <p className="text-white/85 text-lg text-center text-shadow mb-10">
            Have a project, a role, or just want to talk shop? My inbox is
            open.
          </p>
        </Reveal>

        <Reveal delay={100}>
          <form
            onSubmit={handleSubmit}
            className="bg-dusk-900/70 border border-white/10 rounded-2xl p-8 space-y-5"
          >
            <div>
              <label
                className="block text-left text-sm font-medium text-white/80 mb-2"
                htmlFor="userEmail"
              >
                Your email
              </label>
              <input
                id="userEmail"
                type="email"
                name="userEmail"
                value={form.userEmail}
                onChange={handleChange}
                placeholder="you@example.com"
                required
                className={inputClasses}
              />
            </div>
            <div>
              <label
                className="block text-left text-sm font-medium text-white/80 mb-2"
                htmlFor="subject"
              >
                Subject
              </label>
              <input
                id="subject"
                type="text"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder="What's this about?"
                required
                className={inputClasses}
              />
            </div>
            <div>
              <label
                className="block text-left text-sm font-medium text-white/80 mb-2"
                htmlFor="message"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows={5}
                value={form.message}
                onChange={handleChange}
                placeholder="Tell me about it…"
                required
                className={inputClasses}
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={status === "sending"}
              className="w-full py-3 rounded-xl bg-ember text-white font-semibold shadow-lg shadow-ember/25
                         hover:shadow-ember/40 hover:-translate-y-0.5 transition-all duration-300
                         disabled:opacity-60 disabled:hover:translate-y-0"
            >
              {status === "sending" ? "Sending…" : "Send message"}
            </button>

            {status === "sent" && (
              <p className="text-emerald-400 text-sm text-center">
                Thanks — your message is on its way!
              </p>
            )}
            {status === "error" && (
              <p className="text-ember text-sm text-center">
                Something went wrong. Email me directly at{" "}
                <a
                  href="mailto:lassonalexander@gmail.com"
                  className="underline hover:text-white"
                >
                  lassonalexander@gmail.com
                </a>
                .
              </p>
            )}
          </form>
        </Reveal>

        <Reveal delay={200}>
          <div className="flex justify-center gap-6 mt-10 text-2xl">
            <a
              href="mailto:lassonalexander@gmail.com"
              className="text-white/60 hover:text-ember transition-colors"
              aria-label="Email"
            >
              <i className="far fa-envelope"></i>
            </a>
            <a
              href="https://github.com/AlexanderLasson"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-ember transition-colors"
              aria-label="GitHub"
            >
              <i className="fab fa-github"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/alexander-lasson/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-ember transition-colors"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
        </Reveal>
      </div>

      <footer className="text-center text-white/40 text-sm py-8 mt-16">
        <p>
          © {new Date().getFullYear()} Alexander Lasson · Built with React,
          Three.js &amp; Tailwind
        </p>
      </footer>
    </section>
  );
};

export default Contact;
